import { Box, Divider, Grid, Typography } from '@mui/material'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useTranslation } from 'react-i18next'
import CardHero from '../../../../shared/components/frontoffice/CardHero'
import ShareIcon from '../../../../shared/components/icons/ShareIcon'

dayjs.extend(relativeTime)

interface INovelty {
  id: number
  brand: any
  visibility: number
  title: string
  slug: string
  content: string
  image_url: string
  created_at: string
  favoriteId?: number
}

interface NoveltiesLatestProps {
  novelties: INovelty[]
  cutContent: (content: string) => string
  onFavoriteClick: (id: number) => (state: boolean) => void
}

export default function NoveltiesLatest({ novelties, cutContent, onFavoriteClick }: NoveltiesLatestProps) {
  const { t } = useTranslation(['global'])

  return (
    <>
      <Box display="flex" alignItems="center" pt={1} pb={3}>
        <Typography variant="h6" sx={{ minWidth: 'fit-content' }}>
          {t('last-novelties')}
        </Typography>
        <Divider sx={{ marginLeft: 2, flexShrink: 1 }} />
      </Box>
      <Grid container spacing={2}>
        {novelties.map(novelty => (
          <Grid item xs={12} md={4} key={novelty.id}>
            <CardHero
              type={1}
              redirect={`/novedades/${novelty.slug}`}
              cardBrandName={novelty.brand?.name || ''}
              cardVisibility={novelty.visibility}
              cardImage={`${import.meta.env.VITE_AWS_URL}/novelties/${novelty.image_url}`}
              cardTitle={novelty.title}
              cardDescription={<div dangerouslySetInnerHTML={{ __html: cutContent(novelty.content) }} />}
              cardDate={`${dayjs(novelty.created_at).fromNow()}`}
              cardActions={
                <ShareIcon
                  visibility={novelty.visibility}
                  title={novelty.title}
                  description={novelty.title}
                  link={`${window.location.origin}/novedades/${novelty.slug}${window.location.search}`}
                  type="novelty"
                  multimedia={`${import.meta.env.VITE_AWS_URL}/novelties/${novelty.image_url}`}
                  buttonText={t('share')}
                />
              }
              favoriteState={Boolean(novelty.favoriteId)}
              onClickFavorite={onFavoriteClick(novelty.id)}
            />
          </Grid>
        ))}
      </Grid>
    </>
  )
}
